import { render, staticRenderFns } from "./NavigationBarMember.vue?vue&type=template&id=3ba938bf&scoped=true&"
import script from "./NavigationBarMember.vue?vue&type=script&lang=js&"
export * from "./NavigationBarMember.vue?vue&type=script&lang=js&"
import style0 from "./NavigationBarMember.vue?vue&type=style&index=0&id=3ba938bf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ba938bf",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemIcon } from 'vuetify/lib/components/VList';
installComponents(component, {VIcon,VList,VListItem,VListItemIcon})
